import '.k{height:100%;}.ssr-plugin'
import '.bi{max-width:480px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.eu{max-height:calc(100vh - 192px);}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.cx{border-radius:24px;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.ee{backdrop-filter:blur(48px);}.ssr-plugin'
import '.ef{-webkit-backdrop-filter:blur(48px);}.ssr-plugin'
import '.cv{flex-direction:row;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.ev{padding:20px 24px;}.ssr-plugin'
import '.ew{font-size:20px;}.ssr-plugin'
import '.ex{margin-top:4px;}.ssr-plugin'
import '.ey{overflow-y:scroll;}.ssr-plugin'
import '.ac{scrollbar-width:none;}.ssr-plugin'
import '.h{flex:1;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import '.au{font-size:14px;}.ssr-plugin'
import '.f2{line-height:1.5;}.ssr-plugin'
import '.f3{word-wrap:break-word;}.ssr-plugin'
import '.f4{overflow-wrap:break-word;}.ssr-plugin'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { IconButton } from './IconButton.js'
import { Icon } from '../assets/icons/index.js'
import { ModalWrapper, MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { MOBILE } from '../utils/breakpoints.js'
import { useDictionary } from '../hooks/useDictionary.js'
import { useContentQuery } from '../ctx.js'
import { persistent } from '../constants/index.js'

export const PrivacyModal = ({ setModal }) => {
  const dictionary = useDictionary()
  const { data: privacyHtml } = useContentQuery('privacy', null, persistent)

  return (
    <ModalWrapper onDismiss={() => setModal(false)}>
      <styled.div className="k bi m eu b1 cx e f ee ef"
        style={{
          backgroundColor: `${transparentColor(colors.secondary, 0.1)}`,
          border: `1px solid ${colors.border}`,
          animation: MODAL_PANEL_ANIMATION,
          [MOBILE]: {
            maxHeight: 'none',
            backgroundColor: `${transparentColor(colors.secondary, 0.8)}`,
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
          },
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div className="e cv ao w ev"
          style={{
            borderBottom: `1px solid ${colors.border}`,
          }}
        >
          <h3 className="ew ex">
            {dictionary.privacyPolicy}
          </h3>
          <IconButton
            variant="ghost"
            icon={<Icon type="closeIcon" />}
            onClick={() => setModal(false)}
          />
        </div>
        <styled.div className="ey ac h ev bo au f2 f3 f4"
          style={{
            '& h1': { fontSize: 22, marginBottom: 16, marginTop: 0 },
            '& h2': { fontSize: 18, marginTop: 0, marginBottom: 12 },
            '& h3': { fontSize: 16, marginTop: 20, marginBottom: 8 },
            '& p': { marginTop: 0, marginBottom: 12 },
            '& ul': { marginTop: 0, marginBottom: 12, paddingLeft: 20 },
            '& li': { marginBottom: 4 },
            '& a': {
              color: colors.primary,
              textDecoration: 'underline',
              wordBreak: 'break-word',
            },
          }}
          dangerouslySetInnerHTML={{ __html: privacyHtml ?? '' }}
        />
      </styled.div>
    </ModalWrapper>
  )
}
